// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../app/design/frontend/Netlogiq/farmec/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".Draggable{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-user-drag:none;-webkit-tap-highlight-color:rgba(0,0,0,0);touch-action:pan-y;-webkit-backface-visibility:hidden;backface-visibility:hidden;overscroll-behavior:contain;scroll-behavior:smooth}\n", ""]);
// Exports
module.exports = exports;
